import { AxiosPromise } from 'axios';

import { IAssetAccessLog, IAssetAccessLogPayload } from './interfaces';
import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';

const basePath = '/logs';

/* eslint-disable implicit-arrow-linebreak */

export const getAssetAccessLogs = <T>(): AxiosPromise<IApiResponse<Array<IAssetAccessLog>>> =>
  vaultApi.getInstance().get(`${basePath}/assetAccess`);

export const getCompletedDownloads = <T>(orgId: number): AxiosPromise<IApiResponse<Array<IAssetAccessLog>>> =>
  vaultApi.getInstance().get(`${basePath}/completedDownloads?orgId=${orgId}`);

export const createAssetAccessLog = <T>(payload: IAssetAccessLogPayload): AxiosPromise<IApiResponse<IAssetAccessLog>> =>
  vaultApi.getInstance().post(`${basePath}/assetAccess`, payload);

export const getCompletedPushToClouds = <T>(orgId: number): AxiosPromise<IApiResponse<Array<IAssetAccessLog>>> =>
  vaultApi.getInstance().get(`${basePath}/completedPushToClouds?orgId=${orgId}`);

export const updateAssetAccessLog = <T>(id: string, params: any): AxiosPromise<any> =>
  vaultApi.getInstance().put(`${basePath}/assetAccess/${id}`, params);
